import React, { Component } from 'react';

import { Container, Row, Col, Button } from 'react-bootstrap';

import * as fn from '../library/function';
import * as constants from '../config/constants/AppConstants';
import * as helper from '../library/helper';
import * as util from '../library/utilitys';

import CommonPageHeader from './components/CommonPageHeader';
import CommonToolbar from './components/CommonToolbar';
import CommonToast from './components/CommonToast';
import CommonConfirmModal from './components/CommonConfirmModal';

import CommonTokenExpired from './components/CommonTokenExpired';

/** withRouter */
import withRouter from "./components/withRouter";

/** start individual component */
import InputCommonDataSkillsSet from './inputs/InputCommonDataSkillsSet';
import SearchCommonDataSkillsSet from './searchs/SearchCommonDataSkillsSet';
import DataTableCommonDataSkillsSet from './dataTables/DataTableCommonDataSkillsSet';
/** end individual component */

import * as Actions from './actions/ActionCenter';

import { GlobalStates } from './states/GlobalStates';

/** individual page state */
import { PageDataState } from './states/CommonDataSkillsSetState';

/** requester handle */
import requester from "../library/Requester"; 

/** define end point */
const TABLE = `skills_set`;
const URL = `api/master/${TABLE}`;

const LOOKUP = `api/lookup/`;
class CommonDataSkillsSet extends Component {

    constructor(props){
        super(props);

        this.state = {...GlobalStates, ...PageDataState};
        this.updateState = this.setState.bind(this);
    }

    initialize = async () => {
        await this.loadMasterbase();
        await this.loadDataTable();
    }

    loadMasterbase = async () => {
        const { Parameters } = this.state;

        let skills_set_type = fn.getParameterPrompt(Parameters, 'skills_set_type', 'skills_set_type_id');
        
        let sets = [{key: "skills_set_type", filter: [{ field: 'id', value: skills_set_type?.value}]}];

        Actions.loadMasterbase(this.updateState, sets);
    }

    loadDataTable = async (search=false) => { 
        const { Searchs, DataTable } = this.state;
        await Actions.loadDataTable( 
            this.updateState, 
            `${URL}/pagination`, 
            fn.getInputSearch({...Searchs, page: { id: 'page', value: search ? 1 : DataTable.pagination.currentPage }})
        );
    }

    updateSomething = async (obj, element, pk) => {
        await Actions.updateSomething(this.updateState, `${URL}/update-something`, element, pk, obj, this.loadDataTable);
    }

    reorder = async (obj) => {
        await Actions.reorder(this.updateState,`${URL}/reorder`, obj, this.loadDataTable);
    }

    fetchForEdit = async (obj) => {
        await Actions.fetchForEdit(
            this.updateState,
            `${URL}/${obj.id}`, 
            {element: 'OffCanvas', mode: 'update', bool: true}
        );
    }

    deleteData = async () => {
        const { Deletes } = this.state;
        await Actions.deleteData(this.updateState, `${URL}`, Deletes, this.loadDataTable);
    }

    submitData = async () => {
        const { Action, Inputs, DataTable } = this.state; 
        await Actions.submitData(
            this.updateState,
            `${URL}`,
            Action.Mode, 
            fn.getInputForm({...Inputs}),
            this.loadDataTable,
            this.setDefaultInputs
        );
    }

    parametersControl = async (state) => {
        if (state) {
            const { direction, key, restore, ...object } = state;
            await Actions.parametersPrompt(this.updateState, key, object[key], restore);
        }
    
        const shouldInitialize = !!state; 
        if (shouldInitialize) {
            await this.initialize();
        }
    };

    setDefaultInputs = async () => {
        await Actions.setDefaultInputs(this.updateState, 'skills_set_type', async () => {
            const { Action, Inputs } = this.state;
        
            if (Action.Mode === 'new' && Action.OffCanvas.show === true) {
                let sequenceField = 'seq';
                let filterField = 'skills_set_type_id';
                let result = await Actions.getMaxSequence(this.updateState, URL + '/get-max-sequence', {sequenceField: sequenceField, filter: [{field: filterField, value: Inputs[filterField].value}]});
                if(result.success){ Inputs[sequenceField].value = result.seq; }
                this.setState({Inputs: Inputs});
            }
        });
    }
      
    onBreadcrumbClick = (callback) => { if (typeof callback === "function") { callback(this); } }

    backward = () => {
        const { Parameters } = this.state; 

        const key = 'skills_set_type';
        const restore = { ...Parameters[key] };

        Actions.navigate(this.props.navigate, "/apps/common-data-skills-set-type", {
            direction: "drillup",
            key: key,
            restore: restore,
            [key]: Parameters[key]
        });
    };

    componentDidMount = async () => { 
        await this.parametersControl(this.props.location.state);
    };

    componentDidUpdate = async () => {}
    
    render = () => {

        let { Action, Searchs, DataTable, Parameters, Inputs, InputGroup, Masterbase, Deletes, Operation, Token } = this.state;

        let AppProps = constants.AppProps[helper.getCurrentRoute()];

        return (
            <>
                <Container>

                    <CommonPageHeader 
                        object={AppProps} 
                        onBreadcrumbClick={(callback) => this.onBreadcrumbClick(callback)}
                        backward={(e) => this.backward()}
                    />

                    <CommonTokenExpired Token={Token} />
    
                    <CommonToolbar 
                        config={AppProps.toolbar}
                        
                        Operation={Operation}
                        Deletes={Deletes}

                        onToggleSearch={(e) => Actions.handleToggleItem(this.updateState, 'Operation', 'Search')}

                        onRefreshDataTable={async (e) => await this.loadDataTable()}
                        
                        onCreateItem={(e) => Actions.handleOpenInputForm(this.updateState, 'OffCanvas', 'new', true, this.setDefaultInputs)}
                        onModalAction={(e) => Actions.handleControlModal(this.updateState, e)}
                    />

                    <CommonToast 
                        toast={Action.Toast} 

                        onCloseToast={(e) => Actions.handleCloseToast(this.updateState)}
                    />

                    <CommonConfirmModal 
                        Action={Action}
                        Deletes={Deletes}

                        onCallback={async (e) => { 
                            let result = await Actions.handleControlModal(this.updateState, e);
                            if(result.action){
                                if (result.section === 'Delete'){ await this.deleteData(); }
                            }
                         }}
                    />

                    <SearchCommonDataSkillsSet
                        Action={Action}
                        Searchs={Searchs}
                        InputGroup={InputGroup}
                        Masterbase={Masterbase}
                        Operation={Operation}

                        onInputChange={(e, element) => Actions.handleInputChange(this.updateState, element, e)}

                        onSearch={async (e) => await this.loadDataTable(true)}
                    />

                    <DataTableCommonDataSkillsSet 
                        Action={Action}
                        DataTable={DataTable}
                        Inputs={Inputs}
                        Deletes={Deletes}
                        Operation={Operation}

                        onSetEdit={async (e, obj) => { await this.fetchForEdit(obj); }}
                        onDropDownChange={async(e, element, pk) => { await this.updateSomething(e, element, pk)} }
                        onReorder={async(obj) => { await this.reorder(obj); }}

                        onCheckDelete={(e) => Actions.handleDataTableToggleDelete(this.updateState, e)}
                        onCheckDeleteAll={(e, deletes) => Actions.handleDataTableToggleDeleteAll(this.updateState, e, deletes)}
                        onPaginationChange={(paging) => Actions.handleDataTablePaginationChange(this.updateState, paging, this.loadDataTable)}
                    />

                    <InputCommonDataSkillsSet
                        URL={URL}
                        
                        App={AppProps}

                        Action={Action}
                        Parameters={Parameters}
                        Inputs={Inputs}
                        InputGroup={InputGroup}
                        Masterbase={Masterbase}
                        Operation={Operation}

                        onUpdateState={(key, value) => Actions.updateState(this.updateState, key, value)}
                        onInputChange={(e, element) => Actions.handleInputChange(this.updateState, element, e)}
                        onCloseAlert={(e) => { Actions.handleCloseAlert(this.updateState, 'Alert', e); }}

                        onSubmit={async (e) => { await this.submitData()}}
                        
                        onDiscardSubmit={(e) => { Actions.handleDiscardInputs(this.updateState, 'Inputs'); }}
                        onClose={(e) => {
                                Actions.handleDiscardInputs(this.updateState, 'Inputs');
                                Actions.handleCloseInputForm(this.updateState, 'OffCanvas')
                            }
                        }
                    />

                </Container>
            </>
        )
    }
}

export default withRouter(CommonDataSkillsSet);